import { render } from "./MaterialRequestStatusBadge.vue?vue&type=template&id=37e7057a&scoped=true"
import script from "./MaterialRequestStatusBadge.vue?vue&type=script&lang=js"
export * from "./MaterialRequestStatusBadge.vue?vue&type=script&lang=js"

import "./MaterialRequestStatusBadge.vue?vue&type=style&index=0&id=37e7057a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e7057a"]])

export default __exports__